import { RecommendationRequest } from "../../types/recommendations/recommendation-request";
import { RecommendationPayload } from "../../types/recommendations/recommendation-response";
import { ZeroQueryContext } from "../../types/searchbox";
import {
    ITopSearchQueriesResponse,
    IPersonalizationPayload
} from "../../types/suggestion-response";
import {
    defaultPersonalizationPayload,
    defaultRecommendationPayload
} from "../suggestions/defaultSuggestionResponse";
import { PageViewLogDataId } from "../pageViewLogDataId";
import { getStoredSearchQueries } from "../queryStorage";

async function fetchDefaultSuggestions(
    context: ZeroQueryContext
): Promise<ITopSearchQueriesResponse> {
    const pageViewLogDataId = PageViewLogDataId.get();
    const headers: Record<string, string> = pageViewLogDataId
        ? { "X-PageView-ID": pageViewLogDataId }
        : {};

    const res = await fetch(`${context.suggestionApiUrl}suggestion/default`, { headers });
    if (!res.ok) return { topSearchQueries: [] };
    return res.json();
}

async function fetchRecommendations(
    recoRequest: RecommendationRequest
): Promise<RecommendationPayload> {
    const request = new Request(`${recoRequest.apiUrl}recommendations/${recoRequest.configId}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(recoRequest.requestData)
    });

    const res = await fetch(request);
    if (!res.ok) return defaultRecommendationPayload();
    return res.json();
}

export async function fetchPersonalizedSuggestions(
    context: ZeroQueryContext
): Promise<IPersonalizationPayload> {
    const isEnabled = context.allowAiRecommendations && context.isFeatureEnabled;

    if (!isEnabled) {
        return defaultPersonalizationPayload();
    }

    const recoRequest: RecommendationRequest = {
        apiUrl: context.recoApiUrl,
        configId: "b4503039-ac4f-4a90-888b-4d659a7a558d",
        requestData: {
            allowAiRecommendations: context.allowAiRecommendations,
            isPrivateCustomer: context.isPrivateCustomer
        }
    };

    const storedQueries = getStoredSearchQueries().reverse();

    const [suggestionPayload, recoPayload] = await Promise.all([
        fetchDefaultSuggestions(context),
        fetchRecommendations(recoRequest)
    ]);

    const hasData =
        suggestionPayload.topSearchQueries.length ||
        recoPayload.recommendations.length ||
        storedQueries.length;

    if (!hasData) {
        return defaultPersonalizationPayload();
    }

    return {
        isEnabled,
        topSearchQueries: suggestionPayload.topSearchQueries,
        recommendations: recoPayload.recommendations,
        currencyInformation: recoPayload.currencyInformation,
        storedQueries
    };
}
